import React, {useEffect, useState} from "react";
import ReactApexChart from "react-apexcharts";
import axios from "axios";
import {useAuthHeader} from "react-auth-kit";
import {useColorModeValue} from "@chakra-ui/react";

function PaymentChart({getAction, txParam}) {
    const textColor = useColorModeValue("#414040", "#f6f5f5");
    const token = useAuthHeader();
    const [action, setAction] = useState(false)
    const [pay, setPay] = useState([])
    const [out, setOut] = useState([])

    useEffect(() => {
        setAction(getAction)
    },[getAction])

    useEffect(() => {
        if (action){
            let active = true
                const getResult = async () => {
                    if (active) {
                        const result = await fetchData('payment', txParam, token());
                        let fourteenData = getArrFourteen()

                        let fourteenDataAddValue = {};
                        for (const key of fourteenData) {
                            fourteenDataAddValue[key] = 0;
                        }
                        let p = { ...fourteenDataAddValue, ...result }

                        let pay = []
                        for (const key in p) {
                            pay.push(p[key])
                        }
                        setPay(pay)

                        return () => {
                            active = false;
                        };
                    }
                }
                getResult().then();
                return () => {
                    active = false;
                };
            }
    },[action, txParam])

    useEffect(() => {
        if (action){
            let active = true
            const getResult = async () => {
                if (active) {
                    const result = await fetchData('payout', txParam, token());
                    let fourteenData = getArrFourteen()

                    let fourteenDataAddValue = {};
                    for (const key of fourteenData) {
                        fourteenDataAddValue[key] = 0;
                    }
                    let p = { ...fourteenDataAddValue, ...result }

                    let pay = []
                    for (const key in p) {
                        pay.push(p[key])
                    }
                    setOut(pay)

                    return () => {
                        active = false;
                    };
                }
            }
            getResult().then();
            return () => {
                active = false;
            };
        }
    },[action, txParam])

    const lineChartData = [
        {
            name: "Payment",
            data: pay,
        },
        {
            name: "Payout",
            data: out,
        },
    ];

    const lineChartOptions = {
        chart: {
            toolbar: {
                show: false,
            },
        },
        tooltip: {
            theme: "dark",
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            curve: "smooth",
        },
        xaxis: {
            type: "datetime",
            categories: getArrFourteen(),
            labels: {
                style: {
                    colors: textColor,
                    fontSize: "12px",
                },
            },
        },
        yaxis: {
            labels: {
                style: {
                    color: textColor,
                    fontSize: "12px",
                },
            },
        },
        legend: {
            show: false,
        },
        grid: {
            strokeDashArray: 5,
        },
        fill: {
            type: "gradient",
            gradient: {
                shade: "light",
                type: "vertical",
                shadeIntensity: 0.5,
                gradientToColors: undefined,
                inverseColors: true,
                opacityFrom: 0.8,
                opacityTo: 0,
                stops: [],
            },
            colors: ["#4FD1C5", "#548cee"],
        },
        colors: ["#4FD1C5", "#548cee"],
    };

    return (
        <ReactApexChart
            options={lineChartOptions}
            series={lineChartData}
            type="area"
            width="100%"
            height="100%"
        />
    );
}

async function fetchData(type, txParam, token) {
    const response = await axios.get(`/api/v1/transactions/aggregate?aggregate_by=${txParam}&type=${type}&status=Charged&date_trunc_field=started&date_trunc_period=day&started_from=${getFourteen()}`,
        {headers: {Authorization: token}})
    const newData = await response.data;
    const aggregatedBy = txParam.slice(3);

    let data = Object.values(newData.aggr)
    let d = []
    let am = []

    data.forEach(id => {
        d.push(id.started.substring(0,10))
        am.push(id[aggregatedBy])
    })

    let result = {};
    for (let i = 0; i < d.length; ++i)
    {
        let a = d[i];
        let amount = am[i];
        if (txParam === 'tx_sum') {
            if (result[a] !== undefined)
                result[a] += Math.ceil(amount/100.0);
            else
                result[a] = Math.ceil(amount/100.0);
        } else {
            if (result[a] !== undefined)
                result[a] += Math.ceil(amount);
            else
                result[a] = Math.ceil(amount);
        }

    }
    return result
}

function getFourteen() {
    let nowData = new Date()
    nowData.setDate(nowData.getDate() - 14);
    const yyyy = nowData.getFullYear();
    let mm = nowData.getMonth() + 1; // Months start at 0!
    let dd = nowData.getDate();
    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    return yyyy + '-' + mm +  '-' + dd + 'T' + '00:00:00';
}

function getArrFourteen() {
    let arr = [];
    for (let i = 14; i >= 0; i--) {
        let nowData = new Date()
        nowData.setDate(nowData.getDate() - i);
        let yyyy = nowData.getFullYear();
        let mm = nowData.getMonth() + 1;
        let dd = nowData.getDate();
        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;
        arr.push(yyyy + '-' + mm +  '-' + dd)
    }
    return arr
}

export default PaymentChart;
